import isBrowser from "utils/isBrowser"

export default function getFacebookShareLink(href) {
  return "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(
    process.env.NODE_ENV==="development" //if this is a development environment
    ? "http://lobbyview.org" + (isBrowser ? window.location.pathname+window.location.search : "") //fb doesn't allow localhost links, so hardcode to point to lobbyview
    : href //else use the non-development link
  )
}
